import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Accordion as AccordionChakra, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Flex } from '@chakra-ui/react';
import { useSemanticTypography } from '@whitbread-eos/utils';
import React, { createElement as _createElement } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Accordion(props) {
  var _accordionOverwriteSt, _titleTextOverwriteSt, _accordionOverwriteSt2, _accordionOverwriteSt3;
  var accordionItems = props.accordionItems,
    _props$allowMultiple = props.allowMultiple,
    allowMultiple = _props$allowMultiple === void 0 ? true : _props$allowMultiple,
    _props$bgColor = props.bgColor,
    bgColor = _props$bgColor === void 0 ? 'lightGrey5' : _props$bgColor,
    accordionOverwriteStyles = props.accordionOverwriteStyles,
    allowToggle = props.allowToggle;
  var getTypographyProps = useSemanticTypography();
  var titleTextOverwriteStyles = (_accordionOverwriteSt = accordionOverwriteStyles === null || accordionOverwriteStyles === void 0 ? void 0 : accordionOverwriteStyles.text) !== null && _accordionOverwriteSt !== void 0 ? _accordionOverwriteSt : {};
  var textItemLegacyTypography = {
    fontSize: titleTextOverwriteStyles.fontSize,
    fontWeight: (_titleTextOverwriteSt = titleTextOverwriteStyles.fontWeight) !== null && _titleTextOverwriteSt !== void 0 ? _titleTextOverwriteSt : 600,
    lineHeight: titleTextOverwriteStyles.lineHeight,
    letterSpacing: titleTextOverwriteStyles.letterSpacing,
    fontFamily: titleTextOverwriteStyles.fontFamily,
    textTransform: titleTextOverwriteStyles.textTransform
  };
  var titleTextLayoutOverwriteStyles = _objectSpread(_objectSpread({}, titleTextOverwriteStyles), {}, {
    fontSize: undefined,
    fontWeight: undefined,
    lineHeight: undefined,
    letterSpacing: undefined,
    fontFamily: undefined,
    textTransform: undefined,
    textStyle: undefined
  });
  var textItemLayoutStyle = _objectSpread({
    textAlign: 'left',
    color: 'darkGrey1',
    flex: 1
  }, titleTextLayoutOverwriteStyles);
  var buttonStyle = _objectSpread(_objectSpread({}, getAccordionButtonStyle(bgColor)), accordionOverwriteStyles === null || accordionOverwriteStyles === void 0 ? void 0 : accordionOverwriteStyles.button);
  var panelLayoutStyle = _objectSpread({
    color: 'darkGrey1',
    p: '0 var(--chakra-space-3xl) var(--chakra-space-md) var(--chakra-space-sm)',
    pb: 'var(--chakra-space-md)'
  }, accordionOverwriteStyles === null || accordionOverwriteStyles === void 0 ? void 0 : accordionOverwriteStyles.panel);
  var panelLegacyTypography = {
    lineHeight: (_accordionOverwriteSt2 = accordionOverwriteStyles === null || accordionOverwriteStyles === void 0 || (_accordionOverwriteSt3 = accordionOverwriteStyles.panel) === null || _accordionOverwriteSt3 === void 0 ? void 0 : _accordionOverwriteSt3.lineHeight) !== null && _accordionOverwriteSt2 !== void 0 ? _accordionOverwriteSt2 : '3'
  };
  var itemStyle = _objectSpread(_objectSpread({}, accordionItemStyle), accordionOverwriteStyles === null || accordionOverwriteStyles === void 0 ? void 0 : accordionOverwriteStyles.item);
  var iconStyle = _objectSpread(_objectSpread({}, accordionIconStyle), accordionOverwriteStyles === null || accordionOverwriteStyles === void 0 ? void 0 : accordionOverwriteStyles.icon);
  return _jsx(AccordionChakra, _objectSpread(_objectSpread({
    allowMultiple: allowMultiple,
    reduceMotion: true,
    allowToggle: allowToggle
  }, accordionOverwriteStyles === null || accordionOverwriteStyles === void 0 ? void 0 : accordionOverwriteStyles.container), {}, {
    children: accordionItems.map((item, index) => {
      var _item$title;
      var itemTitle = item === null || item === void 0 || (_item$title = item.title) === null || _item$title === void 0 ? void 0 : _item$title.toString().split(' ').join('_');
      return _createElement(AccordionItem, _objectSpread(_objectSpread({}, itemStyle), {}, {
        key: itemTitle,
        id: "heading-".concat(index)
      }), _jsxs(AccordionButton, _objectSpread(_objectSpread({}, buttonStyle), {}, {
        "data-testid": "Button-".concat(itemTitle),
        onClick: item.onToggleSection,
        children: [_jsx(Flex, _objectSpread(_objectSpread(_objectSpread({}, textItemLayoutStyle), getTypographyProps(textItemLegacyTypography, accordionTitleSemanticTypography)), {}, {
          children: item.title
        })), _jsx(AccordionIcon, _objectSpread({}, iconStyle))]
      })), _jsx(AccordionPanel, _objectSpread(_objectSpread(_objectSpread({}, panelLayoutStyle), getTypographyProps(panelLegacyTypography, accordionPanelSemanticTypography)), {}, {
        bgColor: bgColor,
        children: addListPadding(item.content)
      })));
    })
  }));
}
function addListPadding(node) {
  if (!node) return node;
  if (Array.isArray(node)) {
    return node.map(addListPadding);
  }
  if (typeof node === 'object' && node !== null) {
    var _props2;
    if (['ol', 'ul'].includes(node.type)) {
      var _props;
      return React.cloneElement(node, {
        style: {
          paddingLeft: 'var(--chakra-space-4)'
        }
      }, addListPadding((_props = node.props) === null || _props === void 0 ? void 0 : _props.children));
    }
    return React.cloneElement(node, {}, addListPadding((_props2 = node.props) === null || _props2 === void 0 ? void 0 : _props2.children));
  }
  return node;
}
var accordionItemStyle = {
  cursor: 'pointer',
  fontSize: 'md',
  lineHeight: '3',
  borderBottom: '1px solid var(--chakra-colors-lightGrey4)',
  _hover: {
    bgColor: 'baseWhite'
  }
};
var accordionTitleSemanticTypography = {
  textStyle: 'body-l-emphasis'
};
var getAccordionButtonStyle = bgColor => ({
  p: 'var(--chakra-space-md) 0 var(--chakra-space-md) 0',
  bgColor: 'baseWhite',
  _focus: {
    boxShadow: 'none'
  },
  _expanded: {
    bgColor: bgColor
  },
  _hover: {
    bgColor: 'baseWhite'
  }
});
var accordionPanelSemanticTypography = {
  textStyle: 'body-m-regular'
};
var accordionIconStyle = {
  color: 'darkGrey2',
  fontSize: '1.875rem'
};